// import React, { useEffect, useRef, useState, useCallback } from "react";
// import { createPortal } from "react-dom";
// import {
//   FaChevronLeft,
//   FaChevronRight,
//   FaHeart,
//   FaShoppingCart,
//   FaShareAlt,
// } from "react-icons/fa";
// import { RxCross1 } from "react-icons/rx";
// import TitleHeader from "../TitleHeader";
// import useHorizontalWheel from "../../../../hooks/useHorizontalWheel";
// import "./WatchAndBuy.css";
// import { BASE_URL } from "../../../../constants/configConstants";
// import {
//   getOptimizedUrl,
//   getPrice,
// } from "../../../../constants/globalFunction";

// /** Home strip: loop first N seconds of the short file. Modal uses `fullSrc` (full-length file). */
// const STRIP_PREVIEW_SECONDS = 3;

// const WatchAndBuy = ({ videos = [] }) => {
//   const scrollerRef = useRef(null);
//   const modalVideoRef = useRef(null);
//   const stripVideoRefs = useRef([]);

//   useHorizontalWheel(scrollerRef);

//   const [activeIndex, setActiveIndex] = useState(null);
//   const [canScrollLeft, setCanScrollLeft] = useState(false);
//   const [canScrollRight, setCanScrollRight] = useState(false);
//   const [wishlistedIds, setWishlistedIds] = useState(() => new Set());

//   const toggleWishlist = (id) => {
//     setWishlistedIds((prev) => {
//       const next = new Set(prev);
//       if (next.has(id)) next.delete(id);
//       else next.add(id);
//       return next;
//     });
//   };

//   const handleShare = (video) => {
//     const mediaUrl = BASE_URL + video?.video;
//     const shareData = {
//       title: video?.product?.name || "Watch & Buy",
//       text: video?.product?.name || "Check this out",
//       url: window.location.origin + mediaUrl,
//     };
//     if (navigator.share) {
//       navigator.share(shareData).catch(() => {});
//     } else if (navigator.clipboard) {
//       navigator.clipboard.writeText(shareData.url).catch(() => {});
//     }
//   };

//   const handleAddToCart = (video) => {
//     console.log("Add to cart:", video.product);
//   };

//   const total = videos.length;
//   const active = activeIndex !== null ? videos[activeIndex] : null;
//   const prevVideo = activeIndex > 0 ? videos[activeIndex - 1] : null;
//   const nextVideo =
//     activeIndex !== null && activeIndex < total - 1
//       ? videos[activeIndex + 1]
//       : null;

//   const updateArrows = useCallback(() => {
//     const scroller = scrollerRef.current;
//     if (!scroller) return;
//     const { scrollLeft, scrollWidth, clientWidth } = scroller;
//     setCanScrollLeft(scrollLeft > 4);
//     setCanScrollRight(scrollLeft + clientWidth < scrollWidth - 4);
//   }, []);

//   useEffect(() => {
//     const scroller = scrollerRef.current;
//     if (!scroller) return;
//     updateArrows();
//     scroller.addEventListener("scroll", updateArrows);
//     window.addEventListener("resize", updateArrows);
//     const ro =
//       typeof ResizeObserver !== "undefined"
//         ? new ResizeObserver(updateArrows)
//         : null;
//     if (ro) ro.observe(scroller);
//     return () => {
//       scroller.removeEventListener("scroll", updateArrows);
//       window.removeEventListener("resize", updateArrows);
//       if (ro) ro.disconnect();
//     };
//   }, [updateArrows]);

//   useEffect(() => {
//     const root = scrollerRef?.current;
//     const nodes = stripVideoRefs?.current?.filter(Boolean);
//     if (!nodes.length) return;

//     const tryPlay = (el) => {
//       const p = el.play?.();
//       if (p && typeof p.catch === "function") p.catch(() => {});
//     };

//     if (typeof IntersectionObserver === "undefined") {
//       nodes.forEach(tryPlay);
//       return;
//     }

//     const io = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           const el = entry.target;
//           if (entry.isIntersecting && entry.intersectionRatio >= 0.2) {
//             tryPlay(el);
//           } else {
//             el.pause?.();
//           }
//         });
//       },
//       {
//         ...(root ? { root } : {}),
//         rootMargin: "0px",
//         threshold: [0, 0.2, 0.45],
//       },
//     );

//     nodes.forEach((n) => io.observe(n));
//     return () => io.disconnect();
//   }, []);

//   const goPrev = useCallback(() => {
//     setActiveIndex((i) => (i > 0 ? i - 1 : i));
//   }, []);

//   const goNext = useCallback(() => {
//     setActiveIndex((i) => (i < total - 1 ? i + 1 : i));
//   }, [total]);

//   useEffect(() => {
//     if (activeIndex === null) return;
//     const onKeyDown = (e) => {
//       if (e.key === "Escape") setActiveIndex(null);
//       else if (e.key === "ArrowLeft") goPrev();
//       else if (e.key === "ArrowRight") goNext();
//     };
//     document.addEventListener("keydown", onKeyDown);
//     const prevOverflow = document.body.style.overflow;
//     document.body.style.overflow = "hidden";
//     return () => {
//       document.removeEventListener("keydown", onKeyDown);
//       document.body.style.overflow = prevOverflow;
//     };
//   }, [activeIndex, goPrev, goNext]);

//   const scrollStripBy = (direction) => {
//     const scroller = scrollerRef.current;
//     if (!scroller) return;
//     const track = scroller.querySelector(".watch-buy__track");
//     const card = scroller.querySelector(".watch-buy__card");
//     const gapRaw = parseFloat(getComputedStyle(track || scroller).gap || "0");
//     const gap = Number.isFinite(gapRaw) ? gapRaw : 14;
//     const step = card
//       ? card.getBoundingClientRect().width + gap
//       : Math.max(220, Math.round(scroller.clientWidth * 0.7));
//     scroller.scrollBy({ left: direction * step, behavior: "smooth" });
//   };

//   const handleOverlayClick = (e) => {
//     if (e.target === e.currentTarget) setActiveIndex(null);
//   };

//   const handleStripTimeUpdate = useCallback((e) => {
//     const v = e.currentTarget;
//     if (v.currentTime >= STRIP_PREVIEW_SECONDS) {
//       try {
//         v.currentTime = 0;
//       } catch (_) {
//         /* noop */
//       }
//     }
//   }, []);

//   const handleCardError = (e) => {
//     const card = e.currentTarget.closest(".watch-buy__card");
//     if (card) card.classList.add("watch-buy__card--error");
//   };

//   const handleProductImageError = (e) => {
//     e.currentTarget.style.display = "none";
//     const fallback = e.currentTarget.nextElementSibling;
//     if (fallback) fallback.style.display = "flex";
//   };

//   const handleStripEnded = useCallback((e) => {
//     const v = e.currentTarget;
//     try {
//       v.currentTime = 0;
//       const p = v.play?.();
//       if (p && typeof p.catch === "function") p.catch(() => {});
//     } catch (_) {
//       /* noop */
//     }
//   }, []);

//   return (
//     <section className="watch-buy">
//       <TitleHeader title="Watch & Buy" subtitle="Latest Shorts & Reels" />

//       <div className="watch-buy__container">
//         {canScrollLeft && (
//           <button
//             type="button"
//             className="watch-buy__nav watch-buy__nav--prev"
//             onClick={() => scrollStripBy(-1)}
//             aria-label="Previous"
//           >
//             <FaChevronLeft />
//           </button>
//         )}

//         <div className="watch-buy__marquee" ref={scrollerRef}>
//           <div className="watch-buy__track">
//             {videos.map((video, idx) => (
//               <article
//                 key={video?._id}
//                 className="watch-buy__card"
//                 role="button"
//                 tabIndex={0}
//                 onClick={() => setActiveIndex(idx)}
//                 onKeyDown={(e) => {
//                   if (e.key === "Enter" || e.key === " ") {
//                     e.preventDefault();
//                     setActiveIndex(idx);
//                   }
//                 }}
//               >
//                 <video
//                   ref={(el) => {
//                     if (stripVideoRefs?.current) {
//                       stripVideoRefs.current[idx] = el;
//                     }
//                   }}
//                   className="watch-buy__video"
//                   src={BASE_URL + video?.video}
//                   muted
//                   playsInline
//                   autoPlay
//                   preload="metadata"
//                   onLoadedMetadata={(e) => {
//                     try {
//                       e.currentTarget.currentTime = 0;
//                     } catch (_) {
//                       /* noop */
//                     }
//                   }}
//                   onTimeUpdate={handleStripTimeUpdate}
//                   onEnded={handleStripEnded}
//                   onError={handleCardError}
//                 />
//                 {video?.product && (
//                   <div className="watch-buy__product-pill" aria-hidden="true">
//                     <div className="watch-buy__product-pill-thumb">
//                       <img
//                         src={
//                           video?.product?.image?.image
//                             ? getOptimizedUrl(video?.product?.image?.image)
//                             : ""
//                         }
//                         alt=""
//                         onError={handleProductImageError}
//                       />
//                       <span
//                         className="watch-buy__product-pill-thumb-fallback"
//                         style={{ display: "none" }}
//                       >
//                         {video?.product?.name?.charAt(0) || "?"}
//                       </span>
//                     </div>
//                     <div className="watch-buy__product-pill-info">
//                       <p className="watch-buy__product-pill-name">
//                         {video?.product?.name}
//                       </p>
//                       <p className="watch-buy__product-pill-price">
//                         {getPrice(video?.product?.size)}
//                       </p>
//                     </div>
//                   </div>
//                 )}

//                 <div className="watch-buy__fallback">
//                   <span className="watch-buy__fallback-icon">▶</span>
//                   <p className="watch-buy__fallback-title">
//                     {video?.product?.name}
//                   </p>
//                   <p className="watch-buy__fallback-hint">Video unavailable</p>
//                 </div>
//               </article>
//             ))}
//           </div>
//         </div>

//         {canScrollRight && (
//           <button
//             type="button"
//             className="watch-buy__nav watch-buy__nav--next"
//             onClick={() => scrollStripBy(1)}
//             aria-label="Next"
//           >
//             <FaChevronRight />
//           </button>
//         )}
//       </div>

//       {active &&
//         createPortal(
//           <div
//             className="watch-buy__modal"
//             role="dialog"
//             aria-modal="true"
//             aria-label={active?.product?.name}
//             onClick={handleOverlayClick}
//           >
//             <button
//               type="button"
//               className="watch-buy__modal-close"
//               onClick={(e) => {
//                 e.stopPropagation();
//                 setActiveIndex(null);
//               }}
//               aria-label="Close"
//             >
//               <RxCross1 size={30} aria-hidden />
//             </button>

//             <div className="watch-buy__modal-stage">
//               <div className="watch-buy__modal-nav-slot">
//                 {activeIndex > 0 && (
//                   <button
//                     type="button"
//                     className="watch-buy__modal-nav watch-buy__modal-nav--prev"
//                     onClick={goPrev}
//                     aria-label="Previous video"
//                   >
//                     <FaChevronLeft />
//                   </button>
//                 )}
//               </div>

//               <div className="watch-buy__modal-reels-cluster">
//                 {prevVideo && (
//                   <button
//                     type="button"
//                     className="watch-buy__modal-side watch-buy__modal-side--prev"
//                     onClick={goPrev}
//                     aria-label="Show previous"
//                   >
//                     <video
//                       src={`${BASE_URL + prevVideo?.video}#t=0.5`}
//                       muted
//                       playsInline
//                       preload="metadata"
//                     />
//                   </button>
//                 )}

//               <div className="watch-buy__modal-center">
//                   <video
//                     key={BASE_URL + active?.video}
//                     ref={modalVideoRef}
//                     className="watch-buy__modal-video"
//                     src={BASE_URL + active?.video}
//                     controls
//                     autoPlay
//                     playsInline
//                     preload="auto"
//                   />
//                   {/* {active?.product && (
//                     <div
//                       className="watch-buy__modal-actions"
//                       aria-label="Video actions"
//                     >
//                       <button
//                         type="button"
//                         className={`watch-buy__modal-action ${
//                           wishlistedIds.has(active?._id)
//                             ? "watch-buy__modal-action--active"
//                             : ""
//                         }`}
//                         onClick={() => toggleWishlist(active?._id)}
//                         aria-label="Wishlist"
//                         aria-pressed={wishlistedIds.has(active?._id)}
//                       >
//                         <FaHeart />
//                       </button>
//                       <button
//                         type="button"
//                         className="watch-buy__modal-action"
//                         onClick={() => handleShare(active)}
//                         aria-label="Share"
//                       >
//                         <FaShareAlt />
//                       </button>
//                       <button
//                         type="button"
//                         className="watch-buy__modal-action"
//                         onClick={() => handleAddToCart(active)}
//                         aria-label="Add to cart"
//                       >
//                         <FaShoppingCart />
//                       </button>
//                     </div>
//                   )} */}
//                 </div>

//                 {nextVideo && (
//                   <button
//                     type="button"
//                     className="watch-buy__modal-side watch-buy__modal-side--next"
//                     onClick={goNext}
//                     aria-label="Show next"
//                   >
//                     <video
//                       src={`${BASE_URL + nextVideo?.video}#t=0.5`}
//                       muted
//                       playsInline
//                       preload="metadata"
//                     />
//                   </button>
//                 )}
//               </div>

//               <div className="watch-buy__modal-nav-slot">
//                 {activeIndex < total - 1 && (
//                   <button
//                     type="button"
//                     className="watch-buy__modal-nav watch-buy__modal-nav--next"
//                     onClick={goNext}
//                     aria-label="Next video"
//                   >
//                     <FaChevronRight />
//                   </button>
//                 )}


import React, { useEffect, useRef, useState, useCallback, useMemo } from "react";
import { createPortal } from "react-dom";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { RxCross1 } from "react-icons/rx";
import TitleHeader from "../TitleHeader";
import useHorizontalWheel from "../../../../hooks/useHorizontalWheel";
import "./WatchAndBuy.css";
import { BASE_URL } from "../../../../constants/configConstants";
import {
  getOptimizedUrl,
  getPrice,
  getErrorMessage,
} from "../../../../constants/globalFunction";
import { useDispatch, useSelector } from "react-redux";
import { showErrorToast } from "../../../../utils/toast";
import { string } from "../../../../constants/string";
import { appApiHandler } from "../../../../api/appApiHandler";
import { setCartCount } from "../../../../store/slices/countState";
import CartDrawer from "../../../../components/cart/CartDrawer";

const STRIP_PREVIEW_SECONDS = 3;

const getVideoProductId = (video) =>
  video?.product_id ?? video?.product?._id ?? video?.product?.id ?? null;

const isProductInStock = (unit) => {
  const qty = Number(unit);
  return Number.isFinite(qty) && qty > 0;
};

const WatchAndBuy = ({ videos = [] }) => {
  const scrollerRef = useRef(null);
  const modalVideoRef = useRef(null);
  const stripVideoRefs = useRef([]);

  useHorizontalWheel(scrollerRef);


  const dispatch = useDispatch();
  const { userData } = useSelector((state) => state.userState);

  const [activeIndex, setActiveIndex] = useState(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  const [selectedSize, setSelectedSize] = useState(null);
  const [selectedColor, setSelectedColor] = useState(null);
  const [cartLoading, setCartLoading] = useState(false);
  const [cartProducts, setCartProducts] = useState([]);
  const [fullProduct, setFullProduct] = useState(null);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [isCartDrawerOpen, setIsCartDrawerOpen] = useState(false);

  const total = videos.length;
  const active = activeIndex !== null ? videos[activeIndex] : null;

  const productSizes = useMemo(() => {
    const product = fullProduct || active?.product;
    if (!product) return [];
    if (product.sizes?.length > 0) return product.sizes;
    if (Array.isArray(product.size)) return product.size;
    if (product.size) return [product.size];
    return [];
  }, [active?.product, fullProduct]);

  const productColors = useMemo(() => {
    const product = fullProduct || active?.product;
    return product?.colors || [];
  }, [active?.product, fullProduct]);

  const updateArrows = useCallback(() => {
    const scroller = scrollerRef.current;
    if (!scroller) return;
    const { scrollLeft, scrollWidth, clientWidth } = scroller;
    setCanScrollLeft(scrollLeft > 4);
    setCanScrollRight(scrollLeft + clientWidth < scrollWidth - 4);
  }, []);

  useEffect(() => {
    const scroller = scrollerRef.current;
    if (!scroller) return;
    updateArrows();
    scroller.addEventListener("scroll", updateArrows);
    window.addEventListener("resize", updateArrows);
    const ro =
      typeof ResizeObserver !== "undefined"
        ? new ResizeObserver(updateArrows)
        : null;
    if (ro) ro.observe(scroller);
    return () => {
      scroller.removeEventListener("scroll", updateArrows);
      window.removeEventListener("resize", updateArrows);
      if (ro) ro.disconnect();
    };
  }, [updateArrows]);

  useEffect(() => {
    const root = scrollerRef?.current;
    const nodes = stripVideoRefs?.current?.filter(Boolean);
    if (!nodes.length) return;

    const tryPlay = (el) => {
      const p = el.play?.();
      if (p && typeof p.catch === "function") p.catch(() => { });
    };

    if (typeof IntersectionObserver === "undefined") {
      nodes.forEach(tryPlay);
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const el = entry.target;
          if (entry.isIntersecting && entry.intersectionRatio >= 0.2) {
            tryPlay(el);
          } else {
            el.pause?.();
          }
        });
      },
      {
        ...(root ? { root } : {}),
        rootMargin: "0px",
        threshold: [0, 0.2, 0.45],
      },
    );

    nodes.forEach((n) => io.observe(n));
    return () => io.disconnect();
  }, []);

  const goPrev = useCallback(() => {
    setActiveIndex((i) => (i > 0 ? i - 1 : i));
  }, []);

  const goNext = useCallback(() => {
    setActiveIndex((i) => (i < total - 1 ? i + 1 : i));
  }, [total]);

  useEffect(() => {
    const fetchFullDetails = async () => {
      const pid = getVideoProductId(active);
      if (!pid) {
        setFullProduct(null);
        return;
      }
      setDetailsLoading(true);
      try {
        const response = await appApiHandler.getProductDetails({
          product_id: pid,
        });
        if (response?.status === 200) {
          setFullProduct(response.data);
        }
      } catch (error) {
        console.error("Error fetching full product details:", error);
      } finally {
        setDetailsLoading(false);
      }
    };

    if (active) {
      fetchFullDetails();
    } else {
      setFullProduct(null);
    }
  }, [active]);

  useEffect(() => {
    const product = fullProduct || active?.product;
    if (!product) {
      setSelectedSize(null);
      setSelectedColor(null);
      return;
    }

    const sizes =
      product.sizes?.length > 0
        ? product.sizes
        : Array.isArray(product.size)
          ? product.size
          : product.size
            ? [product.size]
            : [];

    if (sizes.length === 1) {
      setSelectedSize(sizes[0]);
    } else {
      setSelectedSize(null);
    }

    if (product.colors?.length === 1) {
      setSelectedColor(product.colors[0]);
    } else {
      setSelectedColor(null);
    }
  }, [fullProduct, active]);

  const hasInStockSize = useMemo(() => {
    const product = fullProduct || active?.product;
    if (!product) return false;
    const sizes =
      product.sizes?.length > 0
        ? product.sizes
        : Array.isArray(product.size)
          ? product.size
          : product.size
            ? [product.size]
            : [];
    return sizes.some((size) => isProductInStock(size?.unit));
  }, [fullProduct, active?.product]);

  const getCartProducts = useCallback(async () => {
    if (!userData) {
      setCartProducts([]);
      return;
    }
    const reqData = {
      user_id: userData?._id,
    };
    const response = await appApiHandler.getCart(reqData);
    setCartLoading(false);
    if (response?.status === 200) {
      const products = response?.data?.products || [];
      dispatch(setCartCount(products.length));
      setCartProducts(products);
    }
  }, [userData, dispatch]);

  const openCartDrawer = () => {
    setIsCartDrawerOpen(true);
  };

  const closeCartDrawer = () => {
    setIsCartDrawerOpen(false);
    getCartProducts();
  };

  useEffect(() => {
    if (userData?._id) {
      getCartProducts();
    }
    window.addEventListener('cartUpdated', getCartProducts);
    return () => window.removeEventListener('cartUpdated', getCartProducts);
  }, [userData?._id, getCartProducts]);

  const activeProductId = useMemo(
    () =>
      fullProduct?._id ??
      fullProduct?.id ??
      getVideoProductId(active),
    [fullProduct, active],
  );

  const isProductInCart = useMemo(() => {
    const product = fullProduct || active?.product;
    if (!product || !selectedSize || !activeProductId) return false;
    return cartProducts.some((item) => {
      const sameProduct =
        item?._id === activeProductId || item?.product_id === activeProductId;
      const sameSize = item?.size_id === selectedSize?._id;
      if (productColors.length > 0) {
        return sameProduct && sameSize && item?.color_id === selectedColor?._id;
      }
      return sameProduct && sameSize;
    });
  }, [
    cartProducts,
    active?.product,
    fullProduct,
    selectedSize,
    selectedColor,
    activeProductId,
    productColors.length,
  ]);

  const handleAddToCart = async () => {
    if (!userData) {
      showErrorToast(string.error.please_login_to_your_account);
      return;
    }

    if (!selectedSize && productSizes.length > 0) {
      showErrorToast("Please select a size");
      return;
    }

    if (productColors.length > 0) {
      if (!selectedColor || selectedColor?._id === "all-color") {
        showErrorToast("Please select a specific color");
        return;
      }
    }

    const productId = activeProductId;
    if (!productId) {
      showErrorToast(string.error.failed_due_to_internal_error);
      return;
    }

    const reqData = {
      user_id: userData?._id,
      product_id: productId,
      size_id: selectedSize?._id,
      color_id: selectedColor?._id || null,
      qty: 1,
    };

    setCartLoading(true);
    const response = await appApiHandler.addToCart(reqData);

    if (response?.status === 200) {
      await getCartProducts();
      window.dispatchEvent(new CustomEvent("cartUpdated"));
    } else if (response?.message) {
      setCartLoading(false);
      showErrorToast(getErrorMessage(response?.message));
    } else {
      setCartLoading(false);
      showErrorToast(string.error.failed_due_to_internal_error);
    }
  };

  // useEffect(() => {
  //   if (activeIndex === null) return;
  //   const onKeyDown = (e) => {
  //     if (e.key === "Escape") setActiveIndex(null);
  //     else if (e.key === "ArrowLeft") goPrev();
  //     else if (e.key === "ArrowRight") goNext();
  //   };
  //   document.addEventListener("keydown", onKeyDown);
  //   const prevOverflow = document.body.style.overflow;
  //   document.body.style.overflow = "hidden";
  //   return () => {
  //     document.removeEventListener("keydown", onKeyDown);
  //     document.body.style.overflow = prevOverflow;
  //   };
  // }, [activeIndex, goPrev, goNext]);

  useEffect(() => {
    if (activeIndex === null) return;

    const onKeyDown = (e) => {
      if (e.key === "Escape") setActiveIndex(null);
      else if (e.key === "ArrowLeft") goPrev();
      else if (e.key === "ArrowRight") goNext();
    };

    const scrollY = window.scrollY;
    const { body, documentElement: html } = document;

    const prev = {
      bodyOverflow: body.style.overflow,
      htmlOverflow: html.style.overflow,
      bodyPosition: body.style.position,
      bodyTop: body.style.top,
      bodyWidth: body.style.width,
      bodyTouchAction: body.style.touchAction,
    };

    body.style.overflow = "hidden";
    html.style.overflow = "hidden";
    body.style.position = "fixed";
    body.style.top = `-${scrollY}px`;
    body.style.width = "100%";
    body.style.touchAction = "none";

    const preventBackgroundTouch = (e) => {
      const modal = document.querySelector(".watch-buy__modal");
      if (modal && !modal.contains(e.target)) {
        e.preventDefault();
      }
    };

    document.addEventListener("keydown", onKeyDown);
    document.addEventListener("touchmove", preventBackgroundTouch, {
      passive: false,
    });

    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.removeEventListener("touchmove", preventBackgroundTouch);

      body.style.overflow = prev.bodyOverflow;
      html.style.overflow = prev.htmlOverflow;
      body.style.position = prev.bodyPosition;
      body.style.top = prev.bodyTop;
      body.style.width = prev.bodyWidth;
      body.style.touchAction = prev.bodyTouchAction;

      window.scrollTo(0, scrollY);
    };
  }, [activeIndex, goPrev, goNext]);


  const scrollStripBy = (direction) => {
    const scroller = scrollerRef.current;
    if (!scroller) return;
    const track = scroller.querySelector(".watch-buy__track");
    const card = scroller.querySelector(".watch-buy__card");
    const gapRaw = parseFloat(getComputedStyle(track || scroller).gap || "0");
    const gap = Number.isFinite(gapRaw) ? gapRaw : 14;
    const step = card
      ? card.getBoundingClientRect().width + gap
      : Math.max(220, Math.round(scroller.clientWidth * 0.7));
    scroller.scrollBy({ left: direction * step, behavior: "smooth" });
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) setActiveIndex(null);
  };

  const handleStripTimeUpdate = useCallback((e) => {
    const v = e.currentTarget;
    if (v.currentTime >= STRIP_PREVIEW_SECONDS) {
      try {
        v.currentTime = 0;
      } catch (_) {
        /* noop */
      }
    }
  }, []);

  const handleCardError = (e) => {
    const card = e.currentTarget.closest(".watch-buy__card");
    if (card) card.classList.add("watch-buy__card--error");
    console.log("Video Error:", e);
  };

  const handleProductImageError = (e) => {
    e.currentTarget.style.display = "none";
    const fallback = e.currentTarget.nextElementSibling;
    if (fallback) fallback.style.display = "flex";
  };

  const handleStripEnded = useCallback((e) => {
    const v = e.currentTarget;
    try {
      v.currentTime = 0;
      const p = v.play?.();
      if (p && typeof p.catch === "function") p.catch(() => { });
    } catch (_) {
      /* noop */
    }
  }, []);

  return (
    <section className="watch-buy">
      <TitleHeader title="Watch & Buy" subtitle="Latest Shorts & Reels" />
      <div className="watch-buy__container">
        {canScrollLeft && (
          <button
            type="button"
            className="watch-buy__nav watch-buy__nav--prev"
            onClick={() => scrollStripBy(-1)}
            aria-label="Previous"
          >
            <FaChevronLeft />
          </button>
        )}

        <div className="watch-buy__marquee" ref={scrollerRef}>
          <div className="watch-buy__track">

            {videos.map((video, idx) => (


              <article
                key={video?._id}
                className="watch-buy__card"
                role="button"
                tabIndex={0}
                onClick={() => setActiveIndex(idx)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    setActiveIndex(idx);
                  }
                }}
              >

                <video
                  ref={(el) => {
                    if (stripVideoRefs?.current) {
                      stripVideoRefs.current[idx] = el;
                    }
                  }}
                  className="watch-buy__video"
                  src={BASE_URL + video?.video}
                  muted
                  playsInline
                  autoPlay
                  preload="metadata"
                  onLoadedMetadata={(e) => {
                    try {
                      e.currentTarget.currentTime = 0;
                    } catch (_) {
                      /* noop */
                    }
                  }}
                  onTimeUpdate={handleStripTimeUpdate}
                  onEnded={handleStripEnded}
                  onError={handleCardError}
                />
                {video?.product && (

                  <div className="watch-buy__product-pill" aria-hidden="true">
                    <div className="watch-buy__product-pill-thumb">
                      <img
                        src={
                          video?.product?.image?.image
                            ? getOptimizedUrl(video?.product?.image?.image)
                            : ""
                        }
                        alt=""
                        onError={handleProductImageError}
                      />
                      <span
                        className="watch-buy__product-pill-thumb-fallback"
                        style={{ display: "none" }}
                      >
                        {video?.product?.name?.charAt(0) || "?"}
                      </span>
                    </div>
                    <div className="watch-buy__product-pill-info">
                      <p className="watch-buy__product-pill-name">
                        {video?.product?.name}
                      </p>
                      <p className="watch-buy__product-pill-price">
                        ₹{" "}
                        {getPrice(video?.product?.size)?.toLocaleString("en-IN")}
                      </p>
                    </div>
                  </div>
                )}

                <div className="watch-buy__fallback">
                  <span className="watch-buy__fallback-icon">▶</span>
                  <p className="watch-buy__fallback-title">
                    {video?.product?.name}
                  </p>
                  <p className="watch-buy__fallback-hint">Video unavailable</p>
                </div>
              </article>
            ))}
          </div>
        </div>

        {canScrollRight && (
          <button
            type="button"
            className="watch-buy__nav watch-buy__nav--next"
            onClick={() => scrollStripBy(1)}
            aria-label="Next"
          >
            <FaChevronRight />
          </button>
        )}
      </div>

      {active &&
        createPortal(
          <div
            className="watch-buy__modal"
            role="dialog"
            aria-modal="true"
            aria-label={active?.product?.name || "Watch & Buy"}
            onClick={handleOverlayClick}
          >

            {activeIndex > 0 && (
              <button
                type="button"
                className="watch-buy__modal-nav watch-buy__modal-nav--prev watch-buy__modal-nav--edge"
                onClick={(e) => {
                  e.stopPropagation();
                  goPrev();
                }}
                aria-label="Previous video"
              >
                <FaChevronLeft />
              </button>
            )}

            {activeIndex < total - 1 && (
              <button
                type="button"
                className="watch-buy__modal-nav watch-buy__modal-nav--next watch-buy__modal-nav--edge"
                onClick={(e) => {
                  e.stopPropagation();
                  goNext();
                }}
                aria-label="Next video"
              >
                <FaChevronRight />
              </button>
            )}

            <div className="watch-buy__modal-stage">
              <div className="watch-buy__modal-reels-cluster">
                <div className="watch-buy__modal-card">
                  <button
                    type="button"
                    className="watch-buy__modal-close"
                    onClick={(e) => {
                      e.stopPropagation();
                      setActiveIndex(null);
                    }}
                    aria-label="Close"
                  >
                    <RxCross1 size={30} aria-hidden />
                  </button>
                  <div className="watch-buy__modal-center">
                    <video
                      key={BASE_URL + active?.video}
                      ref={modalVideoRef}
                      className="watch-buy__modal-video"
                      src={BASE_URL + active?.video}
                      controls
                      autoPlay
                      playsInline
                      preload="auto"
                    />
                  </div>

                  {active?.product && (
                    <aside
                      className="watch-buy__modal-aside"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <div className="watch-buy__modal-aside-header">
                        <div className="watch-buy__modal-aside-thumb">
                          <img
                            src={
                              active?.product?.image?.image
                                ? getOptimizedUrl(active?.product?.image?.image)
                                : ""
                            }
                            alt=""
                            onError={handleProductImageError}
                          />
                          <span
                            className="watch-buy__modal-aside-thumb-fallback"
                            style={{ display: "none" }}
                          >
                            {active?.product?.name?.charAt(0) || "?"}
                          </span>
                        </div>
                        <div className="watch-buy__modal-aside-info">
                          <h3 className="watch-buy__modal-aside-title">
                            {active?.product?.name}
                          </h3>
                          <p className="watch-buy__modal-aside-price">
                            RS.{" "}
                          {(detailsLoading ? "..." : getPrice(
                            selectedSize || (fullProduct || active?.product)?.size,
                          ))?.toLocaleString("en-IN")}
                          </p>
                        </div>
                      </div>

                      <div className="watch-buy__modal-field">
                        <label
                          className="watch-buy__modal-label"
                          htmlFor="watch-buy-size"
                        >
                          SIZE:
                        </label>
                        <select
                          id="watch-buy-size"
                          className="watch-buy__modal-select"
                          value={selectedSize?._id ?? ""}
                          onChange={(e) => {
                            const size = productSizes.find(
                              (s) => String(s._id) === e.target.value,
                            );
                            setSelectedSize(size || null);
                          }}
                        >
                          <option value="" disabled>Select Size</option>
                          {productSizes.length === 0 ? (
                            <option value="" disabled>No size available</option>
                          ) : (
                            productSizes.map((size) => (
                              <option key={size._id} value={size._id}>
                                {size.size}
                              </option>
                            ))
                          )}
                        </select>
                      </div>

                      <div className="watch-buy__modal-field">
                        <label
                          className="watch-buy__modal-label"
                          htmlFor="watch-buy-color"
                        >
                          COLOR:
                        </label>
                        <select
                          id="watch-buy-color"
                          className="watch-buy__modal-select"
                          value={selectedColor?._id ?? ""}
                          onChange={(e) => {
                            const color = productColors.find(
                              (c) => String(c._id) === e.target.value,
                            );
                            setSelectedColor(color || null);
                          }}
                          disabled={productColors.length === 0}
                        >
                          <option value="" disabled>Select Color</option>
                          {productColors.length === 0 ? (
                            <option value="" disabled>No color</option>
                          ) : (
                            productColors.map((color) => (
                              <option key={color._id} value={color._id}>
                                {color.name}
                              </option>
                            ))
                          )}
                        </select>
                      </div>

                      {hasInStockSize ? (
                        <button
                          type="button"
                          className="watch-buy__modal-cart-btn"
                          onClick={
                            isProductInCart ? openCartDrawer : handleAddToCart
                          }
                          disabled={cartLoading}
                        >
                          {cartLoading
                            ? "Adding..."
                            : isProductInCart
                              ? "Go to Cart"
                              : "Add To Cart"}
                        </button>
                      ) : (
                        <button
                          type="button"
                          className="watch-buy__modal-cart-btn"
                          disabled
                        >
                          Out of Stock
                        </button>
                      )}
                    </aside>
                  )}
                </div>
              </div>
            </div>
          </div>,
          document.body,
        )}

      <CartDrawer isOpen={isCartDrawerOpen} onClose={closeCartDrawer} />
    </section>
  );
};

export default WatchAndBuy;